import styled from 'styled-components';
import { BodyWrapper } from '../CustomerHeader/CustomerHeaderStyledComponents';
import { colors } from '../../styles/Colors';
import BackgroundWeb from '../../assets/images/Background/background.webp';
import BackgroundMiddle from '../../assets/images/Background/backgroundMiddle.webp';
import BackgroundModals from '../../assets/images/Background/backgroundModals.webp';
interface LandingOverlayPageProps {
  shown: boolean;
  backgroundMobile?: boolean; //background modals mobile
}

export const LandingOverlayPage = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const LandingOverlayHeaderContainer = styled.div<LandingOverlayPageProps>`
  width: 100%;
  height: 100%;
  min-height: 46px;
  background-color: ${colors.white};
  justify-content: center;
  align-items: center;
  padding: 0 50px;
  gap: 25px;
  display: ${(props) => (props.shown === true ? 'flex' : 'none')};
`;

export const LandingOverlaySection = styled.div`
  width: 100%;
`;

export const LandingOverlayBg = styled.div`
  width: 100%;
  height: 100%;
  background-image: url('LandingHeaderBg.svg');
  background-repeat: no-repeat;
  max-width: 30%;
`;

export const LandingOverlayImg = styled.div`
  width: 100%;
  height: 100%;
  background-image: url('LandingHeaderLine.svg');
  background-repeat: no-repeat;
`;

export const HeaderPepperIcon = styled.img`
  width: 83px;
  height: 30px;
`;

export const LandingContentBg = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;

  @media (min-width: 850px) {
    background-color: ${colors.gray12};
    background-image: url('./LandingBackground1.svg'),
      url('./LandingBackground2.svg');
    background-repeat: no-repeat;
    background-position: right top, left bottom;
    background-size: 160px, 320px;
  }
`;

export const LandingContentResized = styled(BodyWrapper)<LandingOverlayPageProps>`
  display: flex;
  width: ${(props) => (props.shown ? 'auto' : '692px')};
  margin: 0;
  padding-top: 20px;
  // from 650px to 850px
  @media (min-width: 651px) and (max-width: 850px) {
    padding: 15px;
  }

  @media (max-width: 650px) {
    padding-top: 0;
  }

  @media (max-width: 850px) {
    width: 100%;
    height: 100%;
    box-shadow: none;
    margin: 0;
  }
`;

export const LandingContainer = styled.div<LandingOverlayPageProps>`
  justify-content: center;
  background-color: ${colors.gray12};
  background-image: ${(props) =>
    props.shown === true ? `url(${BackgroundWeb})` : 'none'};
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-grow: 1;

  @media (min-width: 1600px) {
    background-position: 100%;
  }
  @media (max-width: 1024px) {
    background-image: ${(props) =>
      props.shown === true ? `url(${BackgroundMiddle})` : 'none'};
  }
  @media (max-width: 650px) {
    background-image: none;
    background-image: ${(props) =>
      props.backgroundMobile === true ? `url(${BackgroundModals})` : 'none'};
  }
`;
export const ContentBanner = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  /* margin: auto; */
  padding: 0 30px 16px;
  justify-content: center;
  @media (max-width: 850px) {
    padding: 0;
  }
`;

export const BannerContainer = styled.div<LandingOverlayPageProps>`
  display: ${(props) => (props.shown === true ? 'flex' : 'none')};
  position: relative;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 100%;
  padding-top: 20px;
  margin-left: 20px;

  @media (max-width: 850px) {
    display: none;
  }
`;

export const Banner = styled.img`
  width: 261px;
  height: 624px;

  @media (max-width: 400px) {
    max-width: 100%;
  }
`;

export const PositionedContainer = styled.div`
  position: absolute;
  bottom: 6%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
`;

export const ImageBannerApple = styled.img`
  cursor: pointer;
  width: 109px;
`;
export const ImageBannerGoogle = styled.img`
  cursor: pointer;
  width: 109px;
`;
